import React, {Component} from "react";
import {Link} from "react-router-dom";
import {Alert} from "../../alertServices";
import { post } from '../../networking/Api';
import Constent from '../../networking/Constent';
import { withTranslation } from 'react-i18next';
import "../../Auth.css";

class Signin extends Component {
    state = {
        username: '',
        password: '',
        language:'Danish'
    };

    componentDidMount(){
        document.getElementById("body").classList.add("bg-theme");

        var lng = localStorage.getItem('defaultLng');
        if( (lng  !== null) && (lng  !== 'null') ){
          this.setState({language:lng})
        }
    }
    onSubmit = () => {
        localStorage.clear();
        if(this.state.username===''){
         Alert.error({title: 'Indtast brugernavn'});
         return;
        }
        if(this.state.password===''){
          Alert.error({title: 'Forkert adgangskode'});
          return; 
        }else{
          var formData = new FormData();
          formData.append("email",this.state.username);
          formData.append("password",this.state.password);
          post(Constent.LOGIN,formData).then(response=>{
          //  this.loaderStop();
            if(response.status){
                localStorage.setItem('userid', response.data.userid);
                localStorage.setItem('username', response.data.username);
                localStorage.setItem('email', response.data.email);
                localStorage.setItem('user_type', response.data.user_type);
                localStorage.setItem('profile_image', response.data.profile_image);
                localStorage.setItem('department_id', response.data.department_id);
                localStorage.setItem('schema_id', response.data.schema_id);
                
                this.props.history.push('/forgot-pin')
            }
            else{
              Alert.error({title: response.message});
            }
          })
        } 
      }

      changeLanguage(lng){
        localStorage.setItem('defaultLng',lng);
        this.setState({language:lng})
        if( (lng === 'en') || (lng === 'English')) {
            lng = 'en';
        }else if( (lng === 'dk') || (lng === 'Danish') ){
            lng = 'dk';
        }else if( (lng === 'fr') || (lng === 'French') ){
            lng = 'fr';
        }else if( (lng === 'tr') || (lng === 'TR') ){
            lng = 'tr';
        }else if( (lng === 'hi') || (lng=== 'Hindi') ){
            lng = 'hi';
        }else{
            lng = 'dk';
        }                           
       const {  i18n } = this.props;
       i18n.changeLanguage(lng);
       localStorage.setItem('lng',lng);
    }
    render() {
      const { t } = this.props;
        return (
                <div className="signin-area">
                  <div className="row">
                    <div className="col-sm-12 col-12">
                      <select className="language" value={this.state.language}
                        onChange={e => { this.changeLanguage(e.target.value) }}>
                        <option value="Danish">{t('lang.language_text_danish')}</option>
                        <option value="English">{t('lang.language_text_english')}</option>
                        <option value="French">{t('lang.language_text_french')}</option>
                        <option value="TR">{t('lang.language_text_tr')}</option>
                      </select>

                    </div>
                    <div className="col-sm-12 col-12 text-center">
                      <img src={process.env.PUBLIC_URL + '/assets/img/logo.png'} alt="logo" />
                    </div>
                  </div>
              <div className="container">
                      <p className="title">{t('lang.auth_sc_forget_pin_login')}</p>
                        <form className="contact-form-inner"
                        onSubmit={e => {
                            e.preventDefault();
                            this.onSubmit();
                        }}>
                            <label className="input-group">
                                <input type="text" placeholder={t('lang.auth_sc_username_email')} className="form-control"
                                onChange={event=>{this.setState({ username: event.target.value })}} />
                                <div className="input-group-append">
                                  <span className="input-group-text"><i className="fa fa-user-circle-o"></i></span>
                                </div>
                            </label>

                            <label className="input-group">
                                <input type="password" placeholder={t('lang.auth_sc_password')} className="form-control"
                                 onChange={event=>{this.setState({ password: event.target.value })}} />
                                <div className="input-group-append">
                                  <span className="input-group-text"><i className="fa fa-lock"></i></span>
                                </div>
                            </label>
                            <button type="submit" className="btn-c btn-primary btn-block btn-square mb-2" onClick={()=>{this.onSubmit()}}>{t('lang.auth_sc_sign_in')}</button>
                            <Link className="forgot-btn" to={'/pin-verification'}>{t('lang.auth_sc_back_to_pin')}?</Link>
                        </form>
                    </div>
                </div>
            
        );
    }
}

export default withTranslation('common')(Signin);